import { render, staticRenderFns } from "./AssetsIndex.vue?vue&type=template&id=529ab464"
import script from "./AssetsIndex.vue?vue&type=script&lang=js"
export * from "./AssetsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports